/* Planet TRP — collection filters/sort (sections/planet-collection.liquid). The form is a plain GET and
   works without this; here it just applies changes immediately and keeps empty price fields out of
   the URL (an empty filter.v.price.gte= would otherwise be sent). */
(function () {
  "use strict";
  document.querySelectorAll('[data-pc-form]').forEach(function (form) {
    function submit() {
      form.querySelectorAll('input[type=number]').forEach(function (i) { if (i.value === '') i.disabled = true; });
      form.classList.add('is-busy'); form.submit();
    }
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('input[type=checkbox], select')) submit();
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
  });
})();
